import React from "react";
import "../css/paysuccess.css";
import { Link, useLocation } from "react-router-dom";
import siteConfig, { formatPrice } from "../config/siteConfig";

const PaySuccess = () => {
  const { state } = useLocation();
  const orderNumber = state?.orderNumber || "HK—CONFIRMED";

  return (
    <main className="success-page">
      <div className="success-page__mark" aria-hidden="true">✓</div>
      <p className="success-page__eyebrow">Order confirmed</p>
      <h1>Thank you for your order.</h1>
      <p className="success-page__copy">
        We are preparing your selection. A confirmation will be sent to the email address provided at checkout.
      </p>
      <dl>
        <div><dt>Order</dt><dd>{orderNumber}</dd></div>
        {state?.total && <div><dt>Total</dt><dd>{formatPrice(state.total)}</dd></div>}
        <div><dt>Status</dt><dd>Confirmed</dd></div>
      </dl>
      <div className="success-page__actions">
        <Link to="/shop">Continue shopping</Link>
        <a href={`mailto:${siteConfig.contact.email}`}>Contact client care</a>
      </div>
    </main>
  );
};

export default PaySuccess;
